// client/src/utils/licenseServerUtils.js
// Shared helper for reading the "is_license_server" flag off a user-product
// through-row, however the API happened to serialize it (Sequelize's default
// `UserProduct` association name, or the legacy `user_products` key).

/**
 * Returns true when the given product entry represents a license-server
 * assignment for the current user (i.e. this user issues/hosts licenses for
 * this product rather than consuming a license themselves).
 *
 * @param {object} product - a product entry as returned alongside a user's
 *   assignment (e.g. from getMyProducts), expected to carry the through-row
 *   under `UserProduct` and/or `user_products`.
 * @returns {boolean}
 */
export const isLicenseServerAssignment = (product) =>
  Boolean(
    product?.UserProduct?.is_license_server ??
      product?.user_products?.is_license_server,
  );
